import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        // AoT requires an exported function for factories
        useFactory: (httpClient: HttpClient) => {
          return new TranslateHttpLoader(httpClient, '/shared/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TranslateModule],
})
export class I18NModule {}
